<template lang="pug">
    aside#contatoWhatsapp(v-if="loaded && showContato")
        a(:href="$configuracoes.whatsappLink", target="_blank")
            FontAwesomeIcon(:icon="icons.faWhatsapp")
</template>

<script>
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

export default {
    name: "component-contato-whatsapp",
    props: {
        showContato: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            icons: {
                faWhatsapp,
            },
            loaded: false,
        }
    },
    created() {
        this.$eventbus.$on('loaded-configuracoes', () => this.loaded = true)
    },
}
</script>

<style lang="stylus" scoped src="./ContatoWhatsapp.styl"></style>